import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { StarSvg } from 'components/icons';
import { Icon } from './atoms';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template: template,
  atoms: [
    {
      component: Icon,
      name: 'Star1',
      displayValue: ({ rating }) => StarSvg({ width: '12', height: '12', filled: rating >= 1, color: '#FFC700' })
    },
    {
      component: Icon,
      name: 'Star2',
      displayValue: ({ rating }) => StarSvg({ width: '12', height: '12', filled: rating >= 2, color: '#FFC700' })
    },
    {
      component: Icon,
      name: 'Star3',
      displayValue: ({ rating }) => StarSvg({ width: '12', height: '12', filled: rating >= 3, color: '#FFC700' })
    },
    {
      component: Icon,
      name: 'Star4',
      displayValue: ({ rating }) => StarSvg({ width: '12', height: '12', filled: rating >= 4, color: '#FFC700' })
    },
    {
      component: Icon,
      name: 'Star5',
      displayValue: ({ rating }) => StarSvg({ width: '12', height: '12', filled: rating === 5, color: '#FFC700' })
    }
  ]
})